import { Divider, EditableText } from '@blueprintjs/core'
import { RematchRootState } from '@rematch/core'
import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as R from 'ramda'
import * as React from 'react'

import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { CardContainer } from '../../components/Card'
import cardStyles from '../../components/Card/card.scss'
import BasicLayout from '../../layouts/BasicLayout'
import { dispatch, models, select, store } from '../../store'
import LectureAudiences from '../LecturePage/lecture-audiences'
import LectureBriefEditor from '../LecturePage/lecture-brief-editor'
import LectureContent from '../LecturePage/lecture-content'
import LectureMissions from '../LecturePage/lecture-missions'
import LectureRequirements from '../LecturePage/lecture-requirements'
import LectureTeachers from '../LecturePage/lecture-teachers'

import buttonStyles from '../../components/Button/button.scss'
import styles from './before-launch.scss'

import Panel from './../LecturePage/launch-panel'

const cx = classnames.bind({ ...styles, ...cardStyles, ...buttonStyles })

type IProps = RouteComponentProps<any> & ReturnType<typeof mapState>
interface IState {
  isEdit: boolean
}
class BeforeLaunchPage extends React.Component<IProps, IState> {
  public state: IState = {
    isEdit: true
  }

  public onLectureTitleChange = (title: string) => {
    const { match } = this.props
    const lectureId = match.params.lectureId
    dispatch.lectures.updateLecture({
      lectureId,
      updated: { title }
    })
  }
  public handleEdit = () => {
    this.setState({ isEdit: !this.state.isEdit })
  }
  public componentDidMount = () => {
    const { match } = this.props
    const lectureId: string = match.params.lectureId
    dispatch.lectureContent.changeCurrentLecture(lectureId)
    dispatch.stats.fetchStats(lectureId)
  }

  public render() {
    const rootState = store.getState()
    const { match } = this.props
    const lectureId: string = match.params.lectureId
    const lecture = select.lectures.getById(rootState, lectureId)
    const participants = select.participants.getByLectureId(
      rootState,
      lectureId
    )
    const currentUser = firebase.auth().currentUser
    const isSpeaker =
      lecture !== null &&
      currentUser !== null &&
      R.contains(currentUser.uid, lecture.speakerIds)
    const isParticipant =
      currentUser !== null &&
      participants !== null &&
      R.contains(currentUser.uid, participants)
    const { isEdit } = this.state

    if (R.isEmpty(lecture) || lecture === null) {
      return null
    }

    return (
      <BasicLayout
        className={cx('before-launch-container', { preivew: !isEdit })}
      >
        {isSpeaker && !isEdit ? (
          <div className={cx('preview-container')}>
            <div className={cx('preview-container-row')}>
              <div className={cx('title')}>預覽畫面</div>
              <div className={cx('button-group')}>
                <p>若送出審核將會有專人於 1 天內與您聯繫</p>
                <a
                  href="#!"
                  className={cx('btn', 'btn--primary', 'btn--fluid', 'btn--lg')}
                  onClick={this.handleEdit}
                >
                  回編輯講座
                </a>
                <a
                  href={`mailto:contact@qraft.app?subject=講座審核&body=lectureId:${lectureId}`}
                  className={cx(
                    'btn',
                    'btn--primary',
                    'btn--line',
                    'btn--fluid',
                    'btn--lg'
                  )}
                >
                  送出審核
                </a>
              </div>
            </div>
          </div>
        ) : null}
        <div className={cx('container')}>
          <div className={cx('row')}>
            {isSpeaker ? (
              <React.Fragment>
                {' '}
                <div className={cx('col-lg-8', 'order-2', 'order-lg-1')}>
                  <CardContainer className={cx('page-before-launch-c__main')}>
                    <div className={cx('header')}>
                      <div className={cx('tag')}>
                        {isEdit ? `編輯講座` : `互動講座`}
                      </div>
                      <h1 className={cx('title')}>
                        {isEdit ? (
                          <EditableText
                            disabled={
                              currentUser
                                ? !R.contains(
                                    currentUser.uid,
                                    lecture.speakerIds
                                  )
                                : true
                            }
                            defaultValue={lecture.title}
                            placeholder="講座名稱"
                            onConfirm={this.onLectureTitleChange}
                          />
                        ) : (
                          lecture.title
                        )}
                      </h1>
                      <Divider className={cx('divider')} />
                    </div>

                    <div className={cx('main')}>
                      <LectureBriefEditor
                        lectureId={lectureId}
                        isEdit={isEdit}
                        content={lecture.description}
                      />
                      <LectureMissions
                        lectureId={lectureId}
                        isEdit={isEdit}
                        missions={lecture.missions}
                      />
                      <LectureContent
                        lectureId={lectureId}
                        isEdit={isEdit}
                        units={lecture.units}
                        lecture={lecture}
                      />
                      <LectureTeachers
                        lectureId={lectureId}
                        isEdit={isEdit}
                        lecture={lecture}
                      />
                      <LectureAudiences
                        lectureId={lectureId}
                        isEdit={isEdit}
                        targetAudiences={lecture.targetAudiences}
                      />
                      <LectureRequirements
                        lectureId={lectureId}
                        isEdit={isEdit}
                        requirements={lecture.requirements}
                      />
                    </div>
                  </CardContainer>
                </div>
                <div className={cx('col-lg-4', 'order-1', 'order-lg-2')}>
                  <CardContainer className={cx('page-before-launch-c__aside')}>
                    <Panel
                      lectureId={lectureId}
                      isSpeaker={isSpeaker}
                      isEdit={isEdit}
                      onhandleEdit={this.handleEdit}
                      isParticipant={isParticipant}
                    />
                  </CardContainer>
                </div>
              </React.Fragment>
            ) : (
              <div>此為講者頁面</div>
            )}
          </div>
        </div>
      </BasicLayout>
    )
  }
}

const mapState = ({ lectures, auth }: RematchRootState<models>) => ({
  lectures,
  auth
})
export default connect(mapState)(BeforeLaunchPage)



// WEBPACK FOOTER //
// ./src/pages/BeforeLaunchPage/index.tsx